import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useQueryXeroGetRedirectUrlToAuthPage = ({
  api,
  opts,
  enabled,
}: {
  api: ApiType;
  opts: Parameters<ApiType["xeroApi"]["getRedirectUrlToAuthPage"]>[0];
  enabled: boolean;
}) =>
  useQuery({
    queryKey: xeroQueryKeys.getRedirectUrlToAuthPage(opts),
    queryFn: async () =>
      (await api.xeroApi.getRedirectUrlToAuthPage(opts)).data,
    enabled,
  });
